export default new class FilterModal {
    constructor() {
        this.init();
    }

    init() {
        this.filterModal = document.getElementById('filterModal');

        document.addEventListener('click', (e) => {
            if (!e.target.matches(`.filter__btn`)) return;

            e.preventDefault();

            callModal('filter');

            /*
            this.filterModal.modal('show', {
                openTransition: 'expandIn',
                openDuration: 400,
                closeTransition: 'expandOut',
                closeDuration: 10,
                backdropClose: true,
                multiple: false,
                wait: true
            });
            */
        });
    }
}